import apiDashboard from '@/api/vo-general/dashboard';

const defaultState = () => ({
	memberGrowList: [],
	tenNewDownlineList: [],
	totalDownline: {},
	potency: {},
	certificate: {},
	announcement: [],
	topSponsor: [],
});

const state = defaultState();

const getters = {
};

const mutations = {
	setMemberGrowList(state, data) {
		state.memberGrowList = data.results;
	},
	setTenNewDownlineList(state, data) {
		state.tenNewDownlineList = data.results;
	},
	setTotalDownline(state, data) {
		state.totalDownline = data.results;
	},
	setPotency(state, data) {
		state.potency = data.results;
	},
	setCertificate(state, data) {
		state.certificate = data.results;
	},
	setAnnouncement(state, data) {
		state.announcement = data.results;
	},
	setTopSponsor(state, data) {
		state.topSponsor = data.results;
	},
};

const actions = {
	getMemberGrow({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getMemberGrow(params).then((results) => {
				const data = results.data.data
				commit('setMemberGrowList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getTenNewDownline({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getTenNewDownline(params).then((results) => {
				const data = results.data.data
				commit('setTenNewDownlineList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getTotalDownline({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getTotalDownline(params).then((results) => {
				const data = results.data.data
				commit('setTotalDownline', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getPotency({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getPotency(params).then((results) => {
				const data = results.data.data
				commit('setPotency', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getCertificate({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getCertificate(params).then((results) => {
				const data = results.data.data
				commit('setCertificate', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getAnnouncements({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getAnnouncements(params).then((results) => {
				const data = results.data.data
				commit('setAnnouncement', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getTopSponsor3({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiDashboard.getTopSponsor3(params).then((results) => {
				const data = results.data.data
				commit('setTopSponsor', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};